export const transactionTableHeaders = {
  NOTE: 'note',
  SYMBOL: 'symbol',
  DATE: 'date',
  DESCRIPTION: 'description',
  SOURCE: 'source',
  CATEGORY: 'category',
  AMOUNT: 'amount',
  REVIEWED: 'reviewed',
  ACTIONS: 'actions',
};
